var link_viewer_default = {
  "fontElementMap": "g-YhA",
  "link": "GS4Kn",
  "linkInEditor": "aQo4B",
  "linkInViewer": "U7mzU",
  "toolbarUrlContainer": "xqrU9",
  "toolbarUrl": "nUPtA",
  "toolbarUrlAnchor": "K6Rk8"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
